import { render, staticRenderFns } from "./TempAccountUpdate.vue?vue&type=template&id=6ad4449c"
import script from "./TempAccountUpdate.vue?vue&type=script&lang=ts"
export * from "./TempAccountUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports